import React from 'react';
import { useNavigate } from "react-router-dom";
import AppFooter from "./AppFooter";
import { FaArrowLeft } from "react-icons/fa";

function TermsOfUse({ hideFooter = false }) {
  const navigate = useNavigate();

  return (
    <>
      <div
        className="terms-of-use-container"
        style={{
          padding: "2rem",
          maxWidth: "800px",
          margin: "0 auto",
          paddingBottom: "5rem", // extra space for fixed footer
          color: "#222",
          background: "#fff",
        }}
      >
        <h1 className="hdr hdr--primary hdr--lg">Terms of Use</h1>
        <h2>Data Controller</h2>
        <p>
          The data controller responsible for your personal information collected through this Service is:
        </p>
        <p>
          <strong>Ionos LLC</strong><br />
          2013 Georgia Ave S,<br />
          Minneapolis, MN 55426<br />
          United States
          <br /><br />
          Email: info@on-screen.app
        </p>
        <p>
          <strong>Effective Date:</strong> 7/1/2025
        </p>

        <p>
          Welcome to On-Screen. By accessing or using our web application (the
          "Service"), you agree to be bound by these Terms of Use ("Terms"). If
          you do not agree to these Terms, please do not use the Service.
        </p>

        <h2>1. Use of the Service</h2>
        <p>
          You must be at least 13 years old to use the Service. You agree to use
          the Service only for lawful purposes and in accordance with these
          Terms.
        </p>

        <h2>2. User Accounts</h2>
        <p>
          You may be required to create an account to use certain features. You
          are responsible for maintaining the confidentiality of your login
          credentials and for all activities under your account.
        </p>

        <h2>3. Content Ownership</h2>
        <p>
          You retain ownership of content you post to the Service. However, by
          posting, you grant us a non-exclusive, royalty-free license to use,
          modify, and display that content in connection with the Service.
        </p>

        <h2>4. Prohibited Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for any unlawful or fraudulent purpose</li>
          <li>Attempt to gain unauthorized access to the system or data</li>
          <li>Post content that is defamatory, obscene, or infringing</li>
        </ul>

        <h2>5. Termination</h2>
        <p>
          We may suspend or terminate your access to the Service at any time,
          without prior notice, if you violate these Terms or use the Service in
          a way that may cause harm.
        </p>

        <h2>6. Disclaimer of Warranties</h2>
        <p>
          The Service is provided "as is" without warranties of any kind. We do
          not guarantee that the Service will be secure, error-free, or always
          available.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, On-Screen shall not be liable
          for any indirect, incidental, or consequential damages arising out of
          your use or inability to use the Service.
        </p>

        <h2>8. Changes to These Terms</h2>
        <p>
          We may update these Terms from time to time. Changes will be posted on
          this page with an updated effective date. Your continued use of the
          Service after changes means you accept the new Terms.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at:{" "}
          <strong>info@on-screen.app</strong>
        </p>
      </div>

      {!hideFooter && (
        <AppFooter
          buttons={[
            {
              icon: <FaArrowLeft />,
              label: "Back",
              onClick: () => navigate(-1),
            },
          ]}
        />
      )}
    </>
  );
}

export default TermsOfUse;